module.exports = __webpack_public_path__ + "img/code.d976b9b1.png";